/**
 * Grieg API - Rendered View (READ ONLY)
 * Service to manage the core configuration details for individual tenants.   ### Design notes Note that in contrast to other services, tenants will be identified by a short code (that can be consistent between environments). This code can be specified as part of the creation and will be ensured is unique.
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type RelationshipLabel =
  | 'ALLOWED_TEAM'
  | 'ASSET_CHILD'
  | 'ASSET_PARENT'
  | 'ASSET_LINKED_ORG'
  | 'ASSET_LINKED_TEAM'
  | 'ASSET_LINKED_USER'
  | 'ASSET_TAG'
  | 'ASSIGNED_TEAM'
  | 'ASSIGNED_USER'
  | 'LINKED_TASK'
  | 'ORG_MEMBER'
  | 'TASK_LINKED_ORG'
  | 'TASK_LINKED_TEAM'
  | 'TASK_LINKED_USER'
  | 'TASK_MERGED_TO'
  | 'TASK_OTHER_ASSET'
  | 'TASK_PRINCIPAL_ASSET'
  | 'TASK_INITIATOR'
  | 'TASK_TAG'
  | 'TEAM_MEMBER';

export const RelationshipLabel = {
  ALLOWEDTEAM: 'ALLOWED_TEAM' as RelationshipLabel,
  ASSETCHILD: 'ASSET_CHILD' as RelationshipLabel,
  ASSETPARENT: 'ASSET_PARENT' as RelationshipLabel,
  ASSETLINKEDORG: 'ASSET_LINKED_ORG' as RelationshipLabel,
  ASSETLINKEDTEAM: 'ASSET_LINKED_TEAM' as RelationshipLabel,
  ASSETLINKEDUSER: 'ASSET_LINKED_USER' as RelationshipLabel,
  ASSETTAG: 'ASSET_TAG' as RelationshipLabel,
  ASSIGNEDTEAM: 'ASSIGNED_TEAM' as RelationshipLabel,
  ASSIGNEDUSER: 'ASSIGNED_USER' as RelationshipLabel,
  LINKEDTASK: 'LINKED_TASK' as RelationshipLabel,
  ORGMEMBER: 'ORG_MEMBER' as RelationshipLabel,
  TASKLINKEDORG: 'TASK_LINKED_ORG' as RelationshipLabel,
  TASKLINKEDTEAM: 'TASK_LINKED_TEAM' as RelationshipLabel,
  TASKLINKEDUSER: 'TASK_LINKED_USER' as RelationshipLabel,
  TASKMERGEDTO: 'TASK_MERGED_TO' as RelationshipLabel,
  TASKOTHERASSET: 'TASK_OTHER_ASSET' as RelationshipLabel,
  TASKPRINCIPALASSET: 'TASK_PRINCIPAL_ASSET' as RelationshipLabel,
  TASKINITIATOR: 'TASK_INITIATOR' as RelationshipLabel,
  TASKTAG: 'TASK_TAG' as RelationshipLabel,
  TEAMMEMBER: 'TEAM_MEMBER' as RelationshipLabel,
};
